import { useUser } from "~/providers/userProvider"
import useShowInternalFeatures from "~/hooks/useShowInternalFeatures"
import { useFlags } from "~/features/feature-flags"
import { isProduction } from "~/utils/environment"

/**
 * Gates the Helix modules in the NAV: staff always outside production; in production only the
 * org's `demandPlanningV2` flag. Reachability, not authorization: the demand2 routers use the
 * standard procedure ladder.
 */
export default function useShowHelix() {
  const { permissions } = useUser()
  const [showInternalFeatures] = useShowInternalFeatures()
  const { demandPlanningV2: demandPlanningV2Flag } = useFlags()

  if (isProduction()) return !!demandPlanningV2Flag
  return (permissions.isStaff && showInternalFeatures) || !!demandPlanningV2Flag
}
